
/* injects from baggage-loader */

'use strict';

import DialogAlertController from '../alert/alert.controller';

import bg from '_images/bg.png';

export default class DialogInterventionalController extends DialogAlertController {
    constructor($log, $rootScope) {
        'ngInject';

        super($log, $rootScope)

        this.$log = $log;
        this.bg = bg;

        this.ballonIndex = 0
    }    
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/interventional/interventional.controller.js